import { createApp } from 'vue'
import App from './App.vue'

import { envsMixin } from "@/services/rest.js";
// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import '../public/style.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import router from './router'

const app = createApp(App)
app.mixin(envsMixin);
app.use(router)
app.component('VueDatePicker', VueDatePicker);

// Use BootstrapVue
// Mount the app
app.mount('#app')
